import { PageButtonKindDropdownType } from "./page-button-kind-dropdown.types";

export const pageButtonKindOptions: PageButtonKindDropdownType[] = [
	{
		value: "confirm",
		label: "Bestätigen-Button",
	},
	{
		value: "link",
		label: "Link-Button",
	},
	{
		value: "textCopy",
		label: "Kopieren-Button",
	},
];
